import { useState, useEffect } from "react";
import "./FormSocials.css";
import { iconPath } from "effno-core";

type FormSocialsProps = {
}

export const FormSocials = ({} : FormSocialsProps) => {
    return (
        <div className="form-socials">
            <a href="https://x.com/effnoco" target="_blank">
                <img src="/social_logos/x.jpg" />
            </a>
            <a href="https://tiktok.com/@effnoco" target="_blank">
                <img src="/social_logos/tiktok.jpg" />
            </a>
            <a href="https://instagram.com/effnoco" target="_blank">
                <img src="/social_logos/instagram.jpg" />
            </a>
            <a href="https://linkedin.com/company/effnoco" target="_blank">
                <img src="/social_logos/linkedin.png" />
            </a>
        </div>
    )
}